
    import { Options, Vue } from 'vue-class-component';
    import _ from 'lodash';
    import swal from 'sweetalert2';

    @Options<FileUpload>({
        name: 'FileUpload',
        props: {
            accept: {
                type: String,
                default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            },
            allowedExtensions: {
                type: Array,
                default: [],
            },
            multi: {
                type: Boolean,
                default: false,
            },
            value: [File, Array],
            disabled: {
                type: Boolean,
                default: false,
            },
            dragtext: {
                type: String,
                required: false,
            },
        },
    })
    export default class FileUpload extends Vue {
        protected readonly accept!: string;
        protected readonly disabled!: boolean;
        protected readonly multi!: boolean;
        protected readonly allowedExtensions!: string[];
        protected readonly value!: File | File[];
        protected readonly dragtext!: string | null;

        public mounted(): void {
            const dropArea = this.$refs.dropzone as HTMLElement;

            ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
                dropArea.addEventListener(
                    eventName,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (e: any) => {
                        e.preventDefault();
                        e.stopPropagation();
                    },
                    false
                );
            });
            ['dragenter', 'dragover'].forEach((eventName) => {
                dropArea.addEventListener(
                    eventName,
                    () => {
                        if (this.disabled) return;
                        dropArea.classList.add('highlight');
                    },
                    false
                );
            });
            ['dragleave', 'drop'].forEach((eventName) => {
                dropArea.addEventListener(
                    eventName,
                    () => {
                        if (this.disabled) return;
                        dropArea.classList.remove('highlight');
                    },
                    false
                );
            });
            dropArea.addEventListener(
                'drop',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (e: any) => {
                    if (this.disabled) return;
                    const dt = e.dataTransfer;
                    const files = dt.files;
                    this.handleFileDrop(files);
                },
                false
            );
        }

        private get filesize(): string | false {
            const f = _.isArray(this.value) ? this.value[0] : this.value;
            return f ? (f.size / 1024).toFixed(2) : false;
        }

        public open(): void {
            (this.$refs.fileinput as HTMLElement).click();
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        private handleFileSelect(event: any): void {
            const f = event.target.files;
            this.handleFileDrop(f);
        }

        private handleFileDrop(files: FileList): void {
            if (files.length == 0) return;
            if (this.disabled) return;
            if (!this.multi && files.length > 1) return;

            let f: File | File[] = Array.from(files);
            if (this.allowedExtensions.length) {
                f = f.filter((x) => this.allowedExtensions.includes(x.name.split('.').reverse()[0]));
            }
            const hasFile = f.length;
            if (!hasFile) {
                swal.fire('Unsupported file type', '', 'warning');
            }
            f = this.multi ? f : f[0];
            this.$emit('input', f);
            if (hasFile) this.$emit('file', f);
        }
    }
